import React, { useState, useEffect, useContext } from 'react';
import { McDrawer, McLoadingIndicator, McLinkButton, McIcon } from "@maersk-global/mds-react-wrapper";
import { TableContext } from "../context";
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';
 
const maerskFontFamily = '"Maersk Text", -apple-system, BlinkMacSystemFont, "Microsoft JhengHei", "Microsoft Yahei", "微软雅黑", STXihei, "华文细黑", sans-serif';
 
function VendorChangeDetailsDrawer({ isdrawerOpen, setisdrawerOpen, drawerChange }) {
    const [drawerData, setDrawerData] = useState(null);
    const [drawerContent, setDrawerContent] = useState("");
    const [drawerHeading, setDrawerHeading] = useState("");
    const { vendorChangeTableData } = useContext(TableContext);
 
    const fetchData = async () => {
        setDrawerData(null);
        try {
            // Find the change data from the vendorChangeTableData context using the unique ID
            const changeData = vendorChangeTableData?.find(item => item["Unique ID"] === drawerChange);
           
            if (changeData) {
                setDrawerData(changeData);
                setDrawerHeading('Vendor Change Details');
               
                // Format dates for display
                const formatDisplayDate = (dateString) => {
                    if (!dateString) return "";
                    try {
                        const dt = DateTime.fromFormat(dateString, 'yyyy-MM-dd HH:mm:ss', { zone: 'utc' });
                        return dt.isValid ? dt.toFormat('dd MMM yyyy HH:mm:ss') + ' UTC' : dateString;
                    } catch {
                        return dateString;
                    }
                };
 
                // Remove HTML tags for display
                const stripHtml = (html) => {
                    if (!html) return "";
                    return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
                };
 
                setDrawerContent(
                    <div style={{ display: "flex", flexDirection: "column", padding: "4px" }}>
                        {/* Change ID */}
                        <div style={{ marginBottom: '20px' }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600", marginBottom: "4px" }}>
                                Change ID
                            </span>
                            <input
                                type="text"
                                value={changeData["Change ID"]}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                    marginTop: "4px"
                                }}
                            />
                        </div>
 
                        {/* Change Details */}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                            {/* Change Title */}
                            <div style={{ flex: "1 1 100%", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Change Title
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222",
                                    wordBreak: "break-word"
                                }}>
                                    {changeData["Change Title"]}
                                </div>
                            </div>
 
                            {/* Category */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Category
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {changeData["Category"]}
                                </div>
                            </div>
 
                            {/* Application ID */}
                            {changeData["Application ID"] && (
                                <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                    <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                        Application ID
                                    </span>
                                    <div style={{
                                        fontSize: "0.95rem",
                                        padding: "8px 12px",
                                        background: "#f7f7f7",
                                        borderRadius: "8px",
                                        color: "#222",
                                        wordBreak: "break-word"
                                    }}>
                                        {changeData["Application ID"]}
                                    </div>
                                </div>
                            )}
 
                            {/* Application Name */}
                            {changeData["Application Name"] && (
                                <div style={{ flex: "1 1 100%", marginBottom: '16px' }}>
                                    <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                        Application Name
                                    </span>
                                    <div style={{
                                        fontSize: "0.95rem",
                                        padding: "8px 12px",
                                        background: "#f7f7f7",
                                        borderRadius: "8px",
                                        color: "#222",
                                        wordBreak: "break-word"
                                    }}>
                                        {changeData["Application Name"]}
                                    </div>
                                </div>
                            )}
 
                            {/* Service Name */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Service Impacted
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {changeData["Service Name"]}
                                </div>
                            </div>
 
                            {/* Region */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Region
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {changeData["Region"]}
                                </div>
                            </div>
 
                            {/* Severity */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Severity
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222",
                                    fontWeight: "500"
                                }}>
                                    {changeData["Severity"]}
                                </div>
                            </div>
 
 
                            {/* Duration */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Duration
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {changeData["Duration"]}
                                </div>
                            </div>
 
                            {/* Scheduled Start Time */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Scheduled Start Time
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {formatDisplayDate(changeData["Scheduled Start Time"])}
                                </div>
                            </div>
 
                            {/* Scheduled End Time */}
                            <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Scheduled End Time
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222"
                                }}>
                                    {formatDisplayDate(changeData["Scheduled End Time"])}
                                </div>
                            </div>
 
                            {/* Grouped Stages */}
                            {changeData["Grouped Stages"] && changeData["Grouped Stages"].length > 0 && (
                                <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                    <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                        Stage Progression
                                    </span>
                                    <div style={{
                                        fontSize: "0.95rem",
                                        padding: "8px 12px",
                                        background: "#ffebebff",
                                        borderRadius: "8px",
                                        color: "#222",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        flexWrap: "wrap"
                                    }}>
                                        {changeData["Grouped Stages"].slice().reverse().map((stage, index, array) => (
                                            <React.Fragment key={index}>
                                                <span>{stage}</span>
                                                {index < array.length - 1 && (
                                                    <McIcon icon="arrow-right"></McIcon>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            )}
 
                            {/* Affected Accounts */}
                            <div style={{ flex: "1 1 100%", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Affected Accounts
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "8px 12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222",
                                    wordBreak: "break-all"
                                }}>
                                    {changeData["Affected Accounts"]}
                                </div>
                            </div>
                           
                            {/* Resource Name */}
                            {changeData["Resource Name"] && (
                                <div style={{ flex: "1 1 calc(50% - 8px)", marginBottom: '16px' }}>
                                    <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                        Resource Affected
                                    </span>
                                    <div style={{
                                        fontSize: "0.95rem",
                                        padding: "8px 12px",
                                        background: "#fcffdeff",
                                        borderRadius: "8px",
                                        color: "#222",
                                        wordBreak: "break-word"
                                    }}>
                                        {changeData["Resource Name"]}
                                    </div>
                                </div>
                            )}
 
                            {/* Impact Summary */}
                            <div style={{ flex: "1 1 100%", marginBottom: '16px' }}>
                                <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                    Impact Summary
                                </span>
                                <div style={{
                                    fontSize: "0.95rem",
                                    padding: "12px",
                                    background: "#f7f7f7",
                                    borderRadius: "8px",
                                    color: "#222",
                                    wordBreak: "break-word",
                                    lineHeight: "1.6",
                                    maxHeight: "300px",
                                    overflowY: "auto"
                                }}>
                                    {stripHtml(changeData["Impact Summary"])}
                                </div>
                            </div>
 
                            {/* Notification Source */}
                            {changeData["Notification Source"] && (
                                <div style={{ flex: "1 1 100%", marginBottom: '16px' }}>
                                    <span style={{ color: "#545454", fontSize: "0.9rem", fontWeight: "600", display: "block", marginBottom: "4px" }}>
                                        Notification Source
                                    </span>
                                    <div style={{
                                        fontSize: "0.85rem",
                                        padding: "8px 12px",
                                        background: "#f7f7f7",
                                        borderRadius: "8px",
                                        color: "#666",
                                        wordBreak: "break-all"
                                    }}>
                                        {changeData["Notification Source"]}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                );
            } else {
                setDrawerData(["No details found for this change"]);
                toast.error("No details found for this Vendor Change", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setDrawerHeading('Vendor Change Details');
                setDrawerContent(
                    <span>No details found for this change</span>
                );
            }
        } catch (error) {
            console.error("Error fetching Vendor Change details", error);
            setDrawerData(["No details found for this change"]);
            toast.error("Error fetching Vendor Change details", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setDrawerHeading('Vendor Change Details');
            setDrawerContent(
                <span>No details found for this change</span>
            );
        }
    };
 
    const handleDrawerClose = () => {
        setisdrawerOpen(false);
        setDrawerContent("");
        setDrawerHeading("");
    };
 
    useEffect(() => {
        fetchData();
    }, [drawerChange]);
 
    return (
        <div>
            <McDrawer
                open={isdrawerOpen}
                closed={handleDrawerClose}
            >
                <span slot="heading">
                    {drawerHeading}
                </span>
 
                {drawerData == null ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <McLoadingIndicator appearance="primary"></McLoadingIndicator>
                    </div>
                ) : (
                    <>
                        <div style={{ marginTop: "10px" }}>{drawerContent}</div>
                    </>
                )}
            </McDrawer>
        </div>
    );
}

export default VendorChangeDetailsDrawer;
